import { fetchBoroughs, fetchByBorough } from "@/lib/practicesService";

const hasBorough = (borough: string | null | undefined): borough is string =>
  typeof borough === "string" && borough.trim().length > 0;

export const toBoroughSlug = (borough?: string | null): string =>
  hasBorough(borough)
    ? borough.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")
    : "";

export const getUniqueBoroughs = async (): Promise<string[]> => fetchBoroughs();

export const getBoroughFromSlug = async (slug: string): Promise<string | undefined> => {
  if (!slug?.trim()) return undefined;
  const boroughs = await fetchBoroughs();
  return boroughs.find((b) => toBoroughSlug(b) === slug);
};

export const getPracticesByBorough = async (borough: string) =>
  hasBorough(borough) ? fetchByBorough(borough) : [];
